import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecurityHeaderBar = _resolveComponent("SecurityHeaderBar")!
  const _component_PasswordField = _resolveComponent("PasswordField")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, null, {
    "content-header": _withCtx(() => [
      _createVNode(_component_SecurityHeaderBar)
    ]),
    "content-top": _withCtx(() => [
      ($data.controller && $data.controller.userProfile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(this.$mhat("SecurityChangePassword.ChangePasswordInstructionText")), 1),
            _createVNode(_component_PasswordField, {
              label: this.$mhat('SecurityChangePassword.CurrentPasswordFieldLabel'),
              id: "currentPassword",
              value: $data.controller.passwords.currentPassword,
              onInput: $options.updatePassword
            }, null, 8, ["label", "value", "onInput"]),
            _createVNode(_component_PasswordField, {
              label: this.$mhat('SecurityChangePassword.ConfirmNewPasswordFieldLabel'),
              id: "newPassword",
              value: $data.controller.passwords.newPassword,
              valid: $data.controller.isValidNewPassword(),
              onInput: $options.updatePassword
            }, null, 8, ["label", "value", "valid", "onInput"]),
            _createVNode(_component_PasswordField, {
              label: this.$mhat('SecurityChangePassword.NewPasswordFieldLabel'),
              id: "confirmPassword",
              value: $data.controller.passwords.confirmPassword,
              valid: $data.controller.isValidConfirmPassword(),
              onInput: $options.updatePassword
            }, null, 8, ["label", "value", "valid", "onInput"])
          ]))
        : _createCommentVNode("", true)
    ]),
    "content-bottom": _withCtx(() => [
      _createVNode(_component_BaseButton, {
        pattern: $data.ButtonColorPattern.FILL,
        color: $data.ButtonColor.PRIMARY,
        disabled: !($data.controller.isValidNewPassword() && $data.controller.isValidConfirmPassword()),
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onSave()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(this.$mhat("SecurityChangePassword.ChangePasswordButtonText")), 1)
        ]),
        _: 1
      }, 8, ["pattern", "color", "disabled"]),
      _createVNode(_component_BaseButton, {
        pattern: $data.ButtonColorPattern.TRANSPARENT,
        color: $data.ButtonColor.DANGER,
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.onCancel()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(this.$mhat("SecurityChangePassword.CancelButtonText")), 1)
        ]),
        _: 1
      }, 8, ["pattern", "color"])
    ]),
    _: 1
  }))
}